import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import ReactQuill from 'react-quill';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link, useHistory } from "react-router-dom";
import arrow_back from '../../assets/icons/arrow-back.svg';
import AddProductSubCategory from './AddProductSubCategory';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer'

const ManageProductsCategory = () => {
    const history = useHistory();
    // Global variables
    const authInfo = JSON.parse(localStorage.getItem("authInfo"));

    //states
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState('');
    const [categories, setCategories] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSubCategory, setShowSubCategory] = useState(false);
    const [selectedCateData, setSelectedCateData] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [indiCate, setIndiCate] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editCateData, setEditCateData] = useState([]);
    const [permission, setPermission] = useState({});

    // NEW: Platform fee modal states
    const [isPlatformFeeModalOpen, setIsPlatformFeeModalOpen] = useState(false);
    const [selectedCategoryForFee, setSelectedCategoryForFee] = useState(null);

    const STRIPE_TAX_CODES = [
        { value: 'txcd_10000000', label: 'General — goods & services' },
        { value: 'txcd_20030000', label: 'Digital — electronically supplied' },
        { value: 'txcd_10103000', label: 'Software / SaaS' },
        { value: 'txcd_20060000', label: 'Professional services' },
    ];

    const handleBack = () => {
        if (window.history.length > 2) {
            history.goBack();
        } else {
            history.push('/admin/dashboard');
        }
    };

    //functions
    useEffect(() => {
        getProductCatePermission();
        getAllCateData();
    }, []);

    useEffect(() => {
        // Force scroll recalculation after data loads
        if (categories.length > 0) {
            setTimeout(() => {
                // Trigger a reflow to recalculate scrollbars
                document.body.style.overflow = 'hidden';
                //document.body.offsetHeight; // Force reflow
                document.body.style.overflow = 'auto';
            }, 100);
        }
    }, [categories]);



    const getProductCatePermission = async () => {
        const admin_Id = authInfo.id;
        try {
            const res = await axios.get(`admin/getProductcatePermission/${admin_Id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            })

            if (res.data.status === true && res.data.data) {
                console.log("res.data.data", res.data.data)

                const permissionss = res.data.data;
                setPermission(permissionss)
                console.log("permissionspermissions", permissionss)
            }

        } catch (error) {
            toast.error(error.response.data.message);
            console.error("Error fetching data: ", error);
        }
    }

    //handle categories for add categories
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        try {
            const token = authInfo.token;
            const admin_id = authInfo.id;

            const productCateData = {
                ...values,
                parent_id: null,
                is_service: false,
                add_to_menu: true,
                admin_id: admin_id
            };

            const response = await axios.post("/admin/create-product-categories", productCateData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message);
                getAllCateData();
                setIsModalOpen(false);
                resetForm();
                setDescription('');
            } else if (response.data.status === false) {
                toast.error(response.data.message);
                getAllCateData();
                setIsModalOpen(false);
                resetForm();
                setDescription('');
            }
        } catch (error) {
            console.error("Categories add failed.", error);
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    //get all categories and display in the list
    const getAllCateData = async () => {
        setLoading(true);
        try {
            const response = await axios.get("/admin/get-product-categories", {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                setCategories(response.data.data);
                setLoading(false);
            } else if (response.data.status === false) {
                toast.error(response.data.message);
            }

        } catch (error) {
            console.error("categories data fetch failed", error);
        }
    };

    const updateStatus = async (row, newStatus) => {
        try {
            const response = await axios.put(`/admin/update-category-status/${row._id}`, {
                isActive: newStatus
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message);
                getAllCateData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Status update failed", error);
            toast.error("An error occurred while updating the status");
        }
    };

    const getIndivisualCate = async (id) => {
        setIsViewModalOpen(true)
        try {
            const response = await axios.get(`/admin/get-indivisual-categories/${id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            })
            if (response.data.status === true && response.data.data.length > 0) {
                setIndiCate(response.data.data[0])
            }
        } catch (error) {
            console.error("Data has not fatched.", error);
        }
    }

    //edit functionality
    const handleEdit = async (id, categoryName, description) => {
        setEditCateData({
            id: id,
            categoryName: categoryName,
            description: description,
            isActive: true
        });
        setIsEditModalOpen(true);
    };

    const handleUpdateSubmit = async (values, { setSubmitting }) => {
        try {
            const admin_id = authInfo.id;
            const updatedData = {
                ...values,
                isActive: editCateData.isActive,
                admin_id: admin_id,
            };

            const response = await axios.put(`/admin/update-product-categories/${values.id}`, updatedData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message);
                getAllCateData();
                setIsEditModalOpen(false);
                setEditCateData([]);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('failed data update.', error);
            toast.error(error.response?.data?.message || 'Failed to update category.');
        } finally {
            setSubmitting(false);
        }
    }

    const handleAddSubCate = (row) => {
        setSelectedCateData({ id: row._id, categoryName: row.categoryName });
        setShowSubCategory(true);
    };

    // ✅ NEW: Platform fee functions
    const handlePlatformFeeModal = (row) => {
        setSelectedCategoryForFee({
            id: row._id || row.id,
            categoryName: row.categoryName,
            currentPlatformFee: row.platformFee || 0,
            currentStripeTaxCode: row.stripeTaxCode || 'txcd_10000000',
        });
        setIsPlatformFeeModalOpen(true);
    };

    const handlePlatformFeeSubmit = async (values, { setSubmitting }) => {
        setLoading(true);
        try {
            const response = await axios.put(`/admin/update-category-platform-fee/${selectedCategoryForFee.id}`, {
                platformFee: parseFloat(values.platformFee),
                stripeTaxCode: values.stripeTaxCode,
                updatedBy: authInfo.id
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message || 'Platform fee updated successfully');
                getAllCateData();
                setIsPlatformFeeModalOpen(false);
                setSelectedCategoryForFee(null);
            } else {
                toast.error(response.data.message || 'Failed to update platform fee');
            }
        } catch (error) {
            console.error("Platform fee update failed", error);
            toast.error(error.response?.data?.message || "An error occurred while updating platform fee");
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    //data table column
    const columns = [
        {
            id: 'categoryName',
            name: 'Category Name',
            selector: row => row.categoryName,
            sortable: true
        },
        {
            name: 'Platform Fee',
            selector: row => (
                <span className="badge bg-info">
                    {row.platformFee || 0}%
                </span>
            ),
            sortable: true
        },
        {
            name: 'Stripe tax code',
            selector: row => (
                <span className="badge bg-secondary font-monospace small">
                    {row.stripeTaxCode || 'txcd_10000000'}
                </span>
            ),
        },
        {
            name: 'Status',
            selector: (row, i) => (
                <span className={`badge ${row.isActive ? 'bg-success' : 'bg-danger'}`}>
                    {row.isActive === true ? 'Active' : 'In-Active'}
                </span>
            ),
            sortable: true
        },
        {
            name: 'Created Date',
            selector: row => new Date(row.createdAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            }),
            sortable: true
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-light border"
                            type="button"
                            id={`dropdownMenuButton-${row.id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="bi bi-three-dots-vertical"></i>
                        </button>

                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${row.id}`}>
                            <li>
                            <button className="dropdown-item" onClick={() => getIndivisualCate(row.id)}>
                                <i className="bi bi-eye me-2"></i> View
                            </button>
                            </li>

                            <li>
                            <button className="dropdown-item" onClick={() => handleEdit(row.id, row.categoryName, row.description)} disabled={!permission.edit}>
                                <i className="bi bi-pen me-2"></i> Edit
                            </button>
                            </li>

                            <li>
                            <button className="dropdown-item" onClick={() => handlePlatformFeeModal(row)} disabled={!permission.edit}>
                                <i className="bi bi-percent me-2"></i> Platform Fee
                            </button>
                            </li>

                            <li>
                            <button className="dropdown-item" onClick={() => updateStatus(row, !row.isActive)}>
                                {row.isActive ? (
                                <>
                                    <i className="bi bi-x-circle me-2"></i> Deactivate
                                </>
                                ) : (
                                <>
                                    <i className="bi bi-check-circle me-2"></i> Activate
                                </>
                                )}
                            </button>
                            </li>

                            <li>
                            <button className="dropdown-item" onClick={() => handleAddSubCate(row)}>
                                <i className="bi bi-diagram-3 me-2"></i> View Sub-Cat
                            </button>
                            </li>
                        </ul>
                        </div>
                        </>
                )
            }
        }
    ];

    //data of table
    const tableData = {
        columns,
        data: categories
    };

    const toggleShowSubCategory = () => {
        setShowSubCategory(false);
    };

    return (
        <React.Fragment>
            {loading && <SpinnerLoader />}
            <div className="container">
                <Header />
                <Helmet>
                    <title>{"Admin - Manage Product Categories - Pay Earth"}</title>
                </Helmet>
                <div className="row">
                    {showSubCategory ? (
                        <AddProductSubCategory cateData={selectedCateData} toggleShowSubCategory={toggleShowSubCategory} />
                    ) : (
                        <div className="col-lg-12">
                            <div className="inr_top_page_title">
                                <h2>Manage Product Categories</h2>
                            </div>
                            <div className="createpost bg-white rounded-3 addPost_left_container">
                                <div className="cp_top d-flex justify-content-between align-items-center">
                                    <div className="cumm_title">Product Categories List</div>
                                    <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                        <button
                                            type="button"
                                            className={`btn custom_btn w-auto ${permission.add ? 'btn_yellow' : 'btn_disabled'}`}
                                            disabled={!permission.add}
                                            onClick={() => {
                                                if (permission.add) {
                                                    setIsModalOpen(true);
                                                }
                                            }}
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            Add-Category
                                        </button>

                                        <div className=''>
                                            <button
                                                type="button"
                                                className="btn custum_back_btn btn_yellow mx-auto"
                                                onClick={handleBack}
                                            >
                                                <img src={arrow_back} alt="back" />&nbsp;
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="cp_body">
                                    <div>
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                columns={columns}
                                                data={categories}
                                                noHeader
                                                defaultSortFieldId="categoryName"
                                                defaultSortAsc={true}
                                                pagination
                                                highlightOnHover
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Existing Add Category Modal */}
                    {isModalOpen && (
                        <div className="modal fade show " style={{ display: 'block' }} tabIndex="-1" aria-modal="true">
                            <div className="modal-dialog  modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Add New Category</h5>
                                        <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <Formik
                                            initialValues={{
                                                name: '',
                                                description: '',
                                            }}
                                            validationSchema={Yup.object({
                                                name: Yup.string().required('Category name is required'),
                                            })}
                                            onSubmit={handleSubmit}
                                        >
                                            {({ isSubmitting, errors, touched, setFieldValue }) => (
                                                <Form>
                                                    <div className="mb-3">
                                                        <label htmlFor="name" className="form-label">Category Name</label>
                                                        <Field
                                                            className="form-control"
                                                            type="text"
                                                            name="name"
                                                        />
                                                        {touched.name && errors.name && (
                                                            <small className="text-danger">{errors.name}</small>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label htmlFor="description" className="form-label">Description</label>
                                                        <ReactQuill
                                                            name="description"
                                                            value={description}
                                                            onChange={(value) => {
                                                                setDescription(value);
                                                                setFieldValue('description', value);
                                                            }}
                                                            modules={{
                                                                toolbar: [
                                                                    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                                                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                                    ['bold', 'italic', 'underline', 'strike'],
                                                                ]
                                                            }}
                                                        />
                                                    </div>

                                                    <button
                                                        type="submit"
                                                        className="btn custom_btn btn_yellow w-auto"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? 'Adding...' : 'Add Category'}
                                                    </button>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Existing Edit Modal */}
                    {isEditModalOpen && editCateData && (
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Edit Category</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => {
                                                setIsEditModalOpen(false);
                                                setEditCateData([]);
                                            }}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <Formik
                                            initialValues={{
                                                id: editCateData.id,
                                                name: editCateData.categoryName,
                                                description: editCateData.description,
                                            }}
                                            validationSchema={Yup.object({
                                                name: Yup.string().required('Category name is required'),
                                            })}
                                            onSubmit={handleUpdateSubmit}
                                        >
                                            {({ isSubmitting, errors, touched, setFieldValue }) => (
                                                <Form>
                                                    <div className="mb-3">
                                                        <label htmlFor="name" className="form-label">Category Name</label>
                                                        <Field
                                                            className="form-control"
                                                            type="text"
                                                            name="name"
                                                        />
                                                        {touched.name && errors.name && (
                                                            <small className="text-danger">{errors.name}</small>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label htmlFor="description" className="form-label">Description</label>
                                                        <Field name="description">
                                                            {({ field, form }) => (
                                                                <ReactQuill
                                                                    value={field.value}
                                                                    onChange={(value) => form.setFieldValue('description', value)}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                                                                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                                            ['bold', 'italic', 'underline', 'strike'],
                                                                        ],
                                                                    }}
                                                                />
                                                            )}
                                                        </Field>
                                                    </div>

                                                    <button
                                                        type="submit"
                                                        className="btn custom_btn btn_yellow"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? 'Updating...' : 'save'}
                                                    </button>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ✅ NEW: Platform Fee Modal */}
                    {isPlatformFeeModalOpen && selectedCategoryForFee && (
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            Fee &amp; tax — {selectedCategoryForFee.categoryName}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => {
                                                setIsPlatformFeeModalOpen(false);
                                                setSelectedCategoryForFee(null);
                                            }}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <Formik
                                            initialValues={{
                                                platformFee: selectedCategoryForFee.currentPlatformFee || 0,
                                                stripeTaxCode: selectedCategoryForFee.currentStripeTaxCode || 'txcd_10000000',
                                            }}
                                            validationSchema={Yup.object({
                                                platformFee: Yup.number()
                                                    .min(0, 'Platform fee cannot be negative')
                                                    .max(100, 'Platform fee cannot exceed 100%')
                                                    .required('Platform fee is required'),
                                                stripeTaxCode: Yup.string().required('Tax category is required'),
                                            })}
                                            onSubmit={handlePlatformFeeSubmit}
                                        >
                                            {({ isSubmitting, errors, touched }) => (
                                                <Form>
                                                    <div className="mb-3">
                                                        <label htmlFor="platformFee" className="form-label">
                                                            Platform Fee (%)
                                                        </label>
                                                        <div className="input-group">
                                                            <Field
                                                                className="form-control"
                                                                type="number"
                                                                name="platformFee"
                                                                step="0.01"
                                                                min="0"
                                                                max="100"
                                                                placeholder="Enter fee percentage"
                                                            />
                                                            <span className="input-group-text">%</span>
                                                        </div>
                                                        {touched.platformFee && errors.platformFee && (
                                                            <small className="text-danger">{errors.platformFee}</small>
                                                        )}
                                                        <small className="form-text text-muted">
                                                            Current fee: {selectedCategoryForFee.currentPlatformFee}%
                                                        </small>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label htmlFor="stripeTaxCode" className="form-label">
                                                            Stripe tax category
                                                        </label>
                                                        <Field as="select" className="form-select" name="stripeTaxCode">
                                                            {STRIPE_TAX_CODES.map((opt) => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </Field>
                                                        <small className="form-text text-muted">
                                                            Stripe Tax sets the rate by buyer location — not a manual percentage.
                                                        </small>
                                                    </div>

                                                    <div className="d-grid gap-2">
                                                        <button
                                                            type="submit"
                                                            className="btn btn_yellow"
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? 'Updating...' : 'Save fee & tax'}
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={() => {
                                                            setIsPlatformFeeModalOpen(false);
                                                            setSelectedCategoryForFee(null);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>

                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Existing View Modal */}
                    {isViewModalOpen && (
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Category Details</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => { setIsViewModalOpen(false); setIndiCate([]); }}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <p><strong>Category Name:</strong> {indiCate?.categoryName}</p>
                                        <p><strong>Description:</strong> {indiCate?.description || ''}</p>
                                        <p><strong>Platform Fee:</strong> {indiCate?.platformFee || 0}%</p>
                                        <p>
                                            <strong>Status:</strong>
                                            <span className={`badge ${indiCate?.isActive ? 'bg-success' : 'bg-danger'}`}>
                                                {indiCate?.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </p>
                                        <p><strong>Creator Name:</strong> {indiCate?.createdBy?.name || ''}</p>
                                        <p><strong>Created Date:</strong> {new Date(indiCate?.createdAt).toLocaleDateString()}</p>
                                        <p><strong>Last Updated:</strong> {new Date(indiCate?.updatedAt).toLocaleDateString()}</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn custom_btn btn_yellow"
                                            onClick={() => { setIsViewModalOpen(false); setIndiCate([]); }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

export default ManageProductsCategory;
